module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-down-teal-05c293a6f2273c124624e1024820ba1a.svg";